import * as THREE from 'three';
import { computeConvexHull2D } from './convexHul';

/**
 * Approximates a disk as a polygon (kernel) with a given number of points.
 */
function createDiskKernel(offsetDistance: number, numPoints = 16) {
  const kernel = [];
  for (let i = 0; i < numPoints; i++) {
    const angle = (i / numPoints) * Math.PI * 2;
    kernel.push(
      new THREE.Vector2(Math.cos(angle) * offsetDistance, Math.sin(angle) * offsetDistance),
    );
  }
  return kernel;
}

/**
 * Computes the Minkowski sum of a polygon and a disk (approximated by a kernel).
 * Returns an offset polygon (as a set of 2D points) by computing the convex hull of the summed points.
 *
 * @param {THREE.Vector2[]} polygon - The original 2D polygon (ordered loop)
 * @param {number} offsetDistance - The offset (radius of the disk)
 */
export const minkowskiOffset2D = (polygon: THREE.Vector2[], offsetDistance: number) => {
  const kernel = createDiskKernel(offsetDistance, 16);
  const offsetPoints: THREE.Vector2[] = [];

  // For each vertex in the polygon, add every kernel offset.
  polygon.forEach((p) => {
    kernel.forEach((k) => {
      offsetPoints.push(new THREE.Vector2(p.x + k.x, p.y + k.y));
    });
  });

  // Compute and return the convex hull of the offset points.
  return computeConvexHull2D(offsetPoints);
};
